import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold uppercase tracking-wide transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange/50 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-brand-orange text-white hover:bg-brand-orange/90 shadow-sm',
        secondary: 'bg-brand-green text-white hover:bg-brand-green/90 shadow-sm',
        outline: 'border border-[var(--ba-surface-border)] bg-transparent hover:bg-[var(--ba-hover-subtle)] dark:hover:bg-white/5',
        ghost: 'hover:bg-[var(--ba-hover-subtle)] dark:hover:bg-white/5',
        destructive: 'bg-brand-danger text-white hover:bg-brand-danger/90',
        info: 'bg-brand-info text-white hover:bg-brand-info/90',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-10 rounded-lg px-3 text-xs',
        lg: 'h-11 px-6',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
  );
});
Button.displayName = 'Button';

export { Button, buttonVariants };
